module.exports = __webpack_public_path__ + "img/firepush_logo.f0559b74.svg";